import * as React from 'react'
import ProgressBar from "./ProgressBar"
import PlayButton from '../../../DVWebNodeStorefront/shared/components/collection/FacetedCarousel/Card/Packshot/PlayButton'
import fireDraperTrackingEvent from '../../../DVWebNodeStorefront/shared/utils/draper'
import * as styles from './PlaybackBlock.module.scss'
import { StorefrontItemPlaybackAction, ItemPrerolls, safeBool } from '@utils'
import { Text } from '@amzn/dvui/dist/Text'
import * as cn from 'classnames'
import { PlayerContext } from '../../../../shared/player/integration/playbackArea'

export interface CommonPlaybackAction extends StorefrontItemPlaybackAction {
    progress?: number
    prerolls?: ItemPrerolls
}

const PlaybackWrapper = ({
  playbackAction,
  children,
}: {
  playbackAction: CommonPlaybackAction
  children: React.ReactChild | React.ReactChild[]
}) => (
  <PlayerContext.Consumer>
    {({ onPlay }) => {
      const onClick = (e: React.MouseEvent) => {
        if (playbackAction.prerolls) {
          fireDraperTrackingEvent(playbackAction.prerolls, 'acceptInvitation')
        }

        if (onPlay) {
          onPlay({
            playbackUrl: playbackAction.fallbackUrl,
            signInUrl: playbackAction.signInUrl,
            contentConfig: {
              asin: playbackAction.titleID,
              videoType: playbackAction.videoMaterialType,
              trailer: false,
              position: playbackAction.resumeTime || 0,
              ref: playbackAction.refMarker,
            },
          })
          e.preventDefault()
        }
      }

      const deeplinkClass =
        onPlay ||
        (Boolean(playbackAction.signInUrl) ||
          safeBool(playbackAction.disableJs))
          ? ''
          : 'js-deeplinkable'
      return (
        <a
          className={cn(deeplinkClass, 'tst-play-button')}
          data-asin={playbackAction && playbackAction.titleID}
          data-ref-tag={playbackAction && playbackAction.refMarker}
          data-ref={playbackAction && playbackAction.refMarker}
          data-resume-time={
            playbackAction && (playbackAction.resumeTime || '0')
          }
          href={playbackAction.fallbackUrl}
          data-video-type={playbackAction && playbackAction.videoMaterialType}
          data-session-id={playbackAction && playbackAction.sessionID}
          data-fallback-url={playbackAction && playbackAction.appFallbackUrl}
          onClick={onClick}>
          {children}
        </a>
      )
    }}
  </PlayerContext.Consumer>
)

export const PlaybackBlock = ({ playbackAction }: { playbackAction: CommonPlaybackAction }) => (
    <>
        <PlaybackWrapper playbackAction={playbackAction}>
            <PlayButton wrapperStyle={styles.playButton}
                circleStyle={styles.circle}
                triangleStyle={styles.triangle}
                svgStyle={styles.svg} />
        </PlaybackWrapper>
        <div className={styles.playbackAction}>
            <Text className={styles.playbackLabel}>{playbackAction.label}</Text>
            <ProgressBar progress={playbackAction.progress} />
        </div>
    </>
)
